<!-- <mat-card>
  <mat-card-header>
    <mat-card-title>Confirme os dados alterados </mat-card-title>
  </mat-card-header>
  <mat-card-content>
 
  </mat-card-content>


</mat-card> -->
<h2 mat-dialog-title *ngIf="!isAddFlow">Confirme os dados alterados</h2>
<h2 mat-dialog-titl *ngIf="isAddFlow">Confirme os dados novos</h2>
<mat-dialog-content>
  <mat-table [dataSource]="valoresAlterados" *ngIf="valoresAlterados.length > 0">
    <ng-container matColumnDef="campo">

      <th mat-header-cell *matHeaderCellDef fxFlex="50%"> Campo </th>
      <td mat-cell *matCellDef="let element" class="p-1 valor-atual"> {{element.title}} </td>



    </ng-container>

    <ng-container matColumnDef="valorAtual" *ngIf="!isAddFlow">
      <th mat-header-cell *matHeaderCellDef fxFlex="50%">Valor Atual</th>
      <td mat-cell *matCellDef="let element" class="p-1 valor-atual"> {{element.valuePrev}} </td>
    </ng-container>

    <ng-container matColumnDef="valorAlterado" *ngIf="!isAddFlow">
      <th mat-header-cell *matHeaderCellDef fxFlex="50%">Valor Alterado</th>
      <td mat-cell *matCellDef="let element" class="p-1 valor-alterado"> {{element.valueC}} </td>

    </ng-container>

    <ng-container matColumnDef="valorNovo" *ngIf="isAddFlow">

      <th mat-header-cell *matHeaderCellDef fxFlex="50%">Valor Novo </th>
      <td mat-cell *matCellDef="let element" class="p-1 valor-atual"> {{element.valueC}} </td>




    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </mat-table>
  <p *ngIf="valoresAlterados.length == 0">
    Sem alterações
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">

  <button mat-raised-button color="primary" (click)="closeModal()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="saveConfirm($event)">Confirmar</button>

</mat-dialog-actions>